import React from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import PageHero from './components/PageHero'
import './Pages.css'

const PHONE = '+90 506 787 31 50'
const ADDRESS = 'Yıldızevler Mahallesi 708. Sokak 23/1, 06550 Yıldız, Çankaya, Ankara'
const MAP_QUERY = encodeURIComponent(ADDRESS)

const SOCIAL = [
  { label: 'Facebook', handle: 'ETHOSTiyatroFestivali', href: 'https://www.facebook.com/ETHOSTiyatroFestivali/', icon: 'fa-facebook' },
  { label: 'Twitter', handle: '@ethos_festival', href: 'https://twitter.com/ethos_festival', icon: 'fa-twitter' },
  { label: 'Instagram', handle: '@ethosankara', href: 'https://www.instagram.com/ethosankara', icon: 'fa-instagram' },
]

export default function Contact() {
  return (
    <React.Fragment>
      <Header />
      <PageHero
        eyebrow='KÜSAGEM'
        title='İletişim'
        lede='Kültür Sanat ve Göç Etkinlikleri Merkezi Derneği'
      />

      <div className='pg' lang='tr'>
        <section className='pg-sun pg-block' aria-label='İletişim bilgileri'>
          <div className='container ct-grid'>
            <ul className='ct-list'>
              <li className='ct-item'>
                <p className='pg-label'>Telefon</p>
                <a className='ct-value' href={`tel:${PHONE.replace(/\s/g, '')}`}>{PHONE}</a>
              </li>
              <li className='ct-item'>
                <p className='pg-label'>Adres</p>
                <address className='ct-address'>
                  Yıldızevler Mahallesi 708. Sokak 23/1<br />
                  06550 Yıldız, Çankaya / Ankara
                </address>
                <div className='ct-actions'>
                  <a
                    className='pg-pill'
                    href={`https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Haritada aç <span aria-hidden='true'>↗</span>
                  </a>
                </div>
              </li>
              <li className='ct-item'>
                <p className='pg-label'>Sosyal medya</p>
                <ul className='ct-social'>
                  {SOCIAL.map((item) => (
                    <li key={item.label}>
                      <a href={item.href} target='_blank' rel='noreferrer'>
                        <i className={`fa ${item.icon}`} aria-hidden='true'></i>
                        <span>{item.handle}</span>
                        <span className='sr-only'> ({item.label})</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>

            <div className='ct-map'>
              <span className='pg-sign'>
                <span className='pg-sign-arrow' aria-hidden='true'>↑</span>
                708. Sokak
              </span>
              <iframe
                title='KÜSAGEM konumu'
                src={`https://maps.google.com/maps?q=${MAP_QUERY}&z=16&output=embed`}
                loading='lazy'
                referrerPolicy='no-referrer-when-downgrade'
              />
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </React.Fragment>
  )
}
